import angular from 'angular';
import uiRouter from 'angular-ui-router';
import mapFilterListComponent from './mapFilterList.component';

let mapFilterListModule = angular.module('mapFilterList', [
  uiRouter
])

.component('mapFilterList', mapFilterListComponent)

.name;

export default mapFilterListModule;
